/**
 * The four figures that answer "what am I owed?": the operator's fees,
 * minus the cash its drivers collected, minus what Pickup Hungary has
 * already paid — what is still owed. All from `/portal/operator/statement`,
 * in the operator's settlement currency; never a customer price.
 */
import React from 'react';
import { formatMoney } from './operatorFormat';

export default function StatementSummary({ statement, title, subtitle = '' }) {
  if (!statement) return null;

  const { currency } = statement;
  const outstanding = Number(statement.outstanding) || 0;
  const owedToOperator = outstanding >= 0;

  const figures = [
    { key: 'fees', label: 'Your fees', value: formatMoney(statement.fees, currency) },
    { key: 'cash', label: 'Cash you collected', value: `− ${formatMoney(statement.cash_collected, currency)}` },
    { key: 'paid', label: 'Already paid to you', value: `− ${formatMoney(statement.paid, currency)}` },
    {
      key: 'owed',
      label: owedToOperator ? 'Still owed to you' : 'You owe Pickup Hungary',
      value: formatMoney(Math.abs(outstanding), currency),
      emphasis: true,
    },
  ];

  return (
    <section className="pp-op-summary" aria-label={title}>
      <div className="pp-op-summary__head">
        <h2 className="pp-op-summary__title">{title}</h2>
        {subtitle ? <div className="pp-op-summary__sub">{subtitle}</div> : null}
      </div>
      <dl className="pp-op-summary__figures">
        {figures.map((figure) => (
          <div
            key={figure.key}
            className={`pp-op-summary__figure${figure.emphasis ? ' is-emphasis' : ''}`}
            data-testid={`statement-${figure.key}`}
          >
            <dt>{figure.label}</dt>
            <dd>{figure.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
